import { GROUP_SETTINGS_DATA_REQUEST_ASYNC } from 'containers/GroupSettings/Table/constants'

import { SUBMIT_UPSELL_SEEN_INDICATION } from '../AwarenessCenter/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'
import { PARTNER_SETTINGS_UPDATE_ASYNC } from '../Settings/PartnerSettings/constants'

import { FETCH_APP_DATA_ASYNC, REFETCH_OWNER_STATUS_ASYNC } from './constants'

const initialState = {
  isDataLoaded: false,
  data: {
    eula: {
      is_first_login: null,
      update_required: null,
    },
    permissions: {},
    licenses: {},
    ff: {},
    tags: [],
    setupStatus: {},
    user: {},
  },
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APP_DATA_ASYNC.SUCCESS: {
      return {
        ...state,
        error: null,
        isDataLoaded: true,
        data: action.payload.data,
      }
    }
    case FETCH_APP_DATA_ASYNC.ERROR:
      return { ...state, error: action.error }
    case FETCH_APP_DATA_ASYNC.CANCEL:
      return { ...state, loader: false }
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS: {
      // data already exist
      if (action.payload.data === null) return state

      let replaced = false
      let companiesData = state.data.partner.companies_data

      companiesData = companiesData.map((e) => {
        if (e.id === action.payload.data.id) {
          replaced = true
          return action.payload.data
        } else return e
      })

      if (!replaced) companiesData.push(action.payload.data)

      return {
        ...state,
        data: {
          ...state.data,
          partner: {
            ...state.data.partner,
            companies_data: companiesData,
          },
        },
      }
    }
    case GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          partner: { ...state.data.partner, companies_data: [] },
        },
      }
    }
    case PARTNER_SETTINGS_UPDATE_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          brand: {
            ...state.data.brand,
            default_rc_company: action.payload.default_rc_company,
            default_awareness_company: action.payload.default_awareness_company,
          },
        },
      }
    case REFETCH_OWNER_STATUS_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      }
    case SUBMIT_UPSELL_SEEN_INDICATION.INITIATE:
      return {
        ...state,
        data: {
          ...state.data,
          disable_premium_popup: true,
        },
      }
    default:
      return state
  }
}
